/*
 * @Author: wp
 * @Date: 2023-01-04 11:01:57
 * @Descripttion:
 */

import Vue from 'vue'
import Router from 'vue-router'
import routers from '@/router/index.js'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch((error) => error)
}

Vue.use(Router)
export function createRouter() {
    return new Router({
        mode: 'history',
        linkActiveClass: 'secondary',
        base: process.env.VUE_APP_apiUrl,
        scrollBehavior: () => ({ y: 0 }),
        routes: routers
    })
}
